import {
  Smile,      // Happy
  Frown,      // Sad
  Annoyed,    // Disgust
  Angry       // Anger
} from 'lucide-react';
import { Stack } from '@mui/material';

const MobileEmojiStack = ({emotionStyles, setInputEmotion}) => {

  return (
      <Stack
        direction="row"
        spacing={1}
        sx={{
          display: { xs: 'flex', xl: 'none' },
          position: 'relative',
          bottom: '0px', // Pushes it above the input bar
          left: '0px', // Adjust based on your Send button width
          backgroundColor: 'white',
          padding: 1,
          margin: 1,
          justifyContent: 'center',
          gap: 5,
          borderRadius: 3,
          boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
          zIndex: 10,
          border: '1px solid #ddd'
        }}
      >

        <Smile color="rgb(3, 3, 3)" size={28} onClick={() => setInputEmotion(emotionStyles.Neutral)} />
        <Smile color="#d1a90aff" size={28} style={{ cursor: 'pointer' }} onClick={() => setInputEmotion(emotionStyles.Happy)} /> {/* Happy */}
        <Frown color="#4A90E2" size={28} style={{ cursor: 'pointer' }} onClick={() => setInputEmotion(emotionStyles.Sad)} /> {/* Sad */}
        <Annoyed color="#2ECC71" size={28} style={{ cursor: 'pointer' }} onClick={() => setInputEmotion(emotionStyles.Annoyed)} /> {/* Annoyed */}
        <Angry color="#E74C3C" size={28} style={{ cursor: 'pointer' }} onClick={() => setInputEmotion(emotionStyles.Angry)} /> {/* Angry */}

      </Stack>
  )
};

export default MobileEmojiStack;